import { WithItineraryBookings } from '@/travelsuit'

import { getItineraryServices } from './getItineraryServices'
import { isFailedBooking } from './isFailedBooking'

export function getItineraryFailedServicesQuantity(itinerary: WithItineraryBookings) {
	return getItineraryServices(itinerary).filter(isFailedBooking).length
}
